export default __webpack_public_path__ + "static/placeholder-464dc0ca3df5f18f373b25185f509007.jpg";